import { Action, isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

export const Message = {
    SUCCESS: 'Operation succeeded',
    ERROR: 'Occurs unexpected error. Verify if you provide correct data or please contact with administrator'
};

export const displayMessage: Middleware = () => next => action => {
    if (isRejectedWithValue(action)) {
        //display error message
        const errorData = action.payload?.data;

        console.log(errorData);

        if (errorData.message) {
            toast.error(errorData.message);
        } else {
            toast.error("Wystąpił nieoczekiwany błąd, spróbuj później!")
        }

    }
    return next(action);
};